<h1 class="fly-away-text">404 Not Found</h1>
<img src="/assets/img/favicon.svg" class="fly-away">
